import { useGetFeatureFlagEnabledQuery } from '@shared/generated/graphql';
import { FeatureFlagName } from 'clerk_common/types/featureFlags';

const DEFAULT_POLL_INTERVAL = 30 * 1000;

type FeatureFlagEnabledProps = {
  name: FeatureFlagName;
  organizationId?: string | null;
  originatorId?: string | null;
  teamId?: string | null;
  userId?: string | null;
  pollingInterval?: number;
};

export const useFeatureFlagEnabled = ({
  name,
  organizationId,
  originatorId,
  teamId,
  userId,
  pollingInterval = DEFAULT_POLL_INTERVAL,
}: FeatureFlagEnabledProps) => {
  const { data, loading, refetch } = useGetFeatureFlagEnabledQuery({
    variables: {
      input: {
        name,
        organizationId,
        originatorId,
        teamId,
        userId,
      },
    },
    pollInterval: pollingInterval,
  });

  return {
    isEnabled: data?.isFeatureFlagEnabled === true,
    loading,
    refetch,
  };
};
